<div [ngClass]="padding? 'paginationComp padding': 'paginationComp'">
  <div class="pag">
    <div class="leyenda">
      Items por página: {{pageSize}}
    </div>
    <div class="pages">
      {{startItem}} - {{endItem}} de {{totalElements}}
      <i class="fa fa-chevron-left" [ngClass]="{'disabled':!prevBool()}" (click)="prev()"></i>
      <i class="fa fa-chevron-right" [ngClass]="{'disabled':!nextBool()}" (click)="next()"></i>
    </div>
  </div>
</div>